<div class="container-fluid px-3 px-md-5 py-4 background-white ">
  <div class="row">
    <div class="col-12 mb-3">
      <h3>{{'homepage.direct-channel.bei.title' | translate}}</h3>
      <h5>{{'homepage.direct-channel.bei.subtitle' | translate}}</h5>
    </div>
  </div>
  <div class="row mx-0 gx-0 gx-sm-3">
    <div class="col-12 col-lg-6 align-self-stretch p-1 m-lg-0 ps-lg-0">
      <div class="container section h-100">
        <div class="row px-3 px-md-5 h-100">
          <div class="col-12 col-lg-5 py-5">
            <h1 class="title">{{'homepage.direct-channel.bei.bandi.title-1' | translate}}
              <br>
                <!-- francesca fazi ask to remove bold -->
                <!-- <b> -->
                {{'homepage.direct-channel.bei.bandi.title-2' | translate}}
              <!-- </b> -->
            </h1>
            @if (newBandi==1) {
              <span class="badge my-2 new-item text-uppercase px-3 py-2">
                {{newBandi}} {{'homepage.direct-channel.bei.bandi.one-new-item' | translate}}
              </span>
            }
            @if (newBandi>1) {
              <span class="badge my-2 new-item text-uppercase px-3 py-2">
                {{newBandi}} {{'homepage.direct-channel.bei.bandi.new-item' | translate}}
              </span>
            }
            <h5>
              {{'homepage.direct-channel.bei.bandi.description' | translate}}
            </h5>
            <div>
              <button (click)="goToBandi()" class="access-module btn btn-primary btn-lg text-uppercase mt-2">
                {{'homepage.direct-channel.bei.open-module' | translate}}
              </button>
            </div>
          </div>
          <div class="col-sm-7 py-2 bando"></div>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-6 align-self-stretch p-1 m-lg-0 pe-lg-0">
      <div class="container section h-100">
        <div class="row px-3 px-md-5 h-100">
          <div class=" col-12 col-lg-5 py-5">
            <h1 class="title">{{'homepage.direct-channel.bei.incentivi.title-1' | translate}}
              <br>
                <!-- <b> -->
                {{'homepage.direct-channel.bei.incentivi.title-2' | translate}}
              <!-- </b> -->
            </h1>
            @if (newIncentivi==1) {
              <span class="badge my-2 new-item text-uppercase px-3 py-2">
                {{newIncentivi}} {{'homepage.direct-channel.bei.incentivi.one-new-item' | translate}}
              </span>
            }
            @if (newIncentivi>1) {
              <span class="badge my-2 new-item text-uppercase px-3 py-2">
                {{newIncentivi}} {{'homepage.direct-channel.bei.incentivi.new-item' | translate}}
              </span>
            }
            <h5>
              {{'homepage.direct-channel.bei.incentivi.description' | translate}}
            </h5>
            <div>
              <button (click)="goToIncentives()" class="access-module btn btn-primary btn-lg text-uppercase mb-2">
              {{'homepage.direct-channel.bei.open-module' | translate}}</button>
            </div>
          </div>
          <div class="col-sm-7 py-2 incentivo"></div>
        </div>
      </div>
    </div>
  </div>
</div>
